import { heroStats, heroHighlights } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"
        aria-hidden="true"
      ></div>
      <div
        className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2 lg:gap-16">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-accent-500"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
            </span>
            线路每日巡检 · 最近更新 2026-10-10
          </span>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            51视频官网入口
            <span className="text-primary-500">、最新地址</span>
            与 App 下载全收录
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            这里汇集 51视频的官网域名、当前可用最新地址、安卓 / iOS / 电视TV 客户端下载，
            以及网页版、App、大屏等多端入口。不管你在找官网还是原来的地址打不开，
            都能在这一页快速定位到能用的访问方式。
          </p>

          <ul className="mt-6 space-y-2.5">
            {heroHighlights.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill mt-0.5 text-accent-500" aria-hidden="true"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#address"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-links-line text-base" aria-hidden="true"></i>
              查看最新地址
            </a>
            <a
              href="#app"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-download-2-line text-base" aria-hidden="true"></i>
              下载客户端
            </a>
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.12s" }}>
          <div className="relative h-[300px] w-full overflow-hidden rounded-2xl border border-background-200 md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20digital%20entertainment%20visual%20with%20warm%20orange%20gradient%20glow%20and%20scattered%20translucent%20glass%20screens%20floating%20in%20dark%20space%2C%20play%20button%20symbols%2C%20soft%20light%20rays%20and%20depth%20of%20field%2C%20premium%20modern%20technology%20render%2C%20high%20detail&width=1200&height=1000&seq=video51-hero-1&orientation=squarish"
              alt="51视频入口汇总主题的抽象数字影像，暖橙色光晕与悬浮屏幕元素"
              className="h-full w-full object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
          </div>

          <div className="absolute -bottom-5 left-4 flex items-center gap-3 rounded-xl border border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur md:left-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-flashlight-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-medium text-foreground-950">智能线路切换</p>
              <p className="text-xs text-foreground-600">主线路卡顿自动推荐备用入口</p>
            </div>
          </div>

          <div className="absolute -top-4 right-4 hidden items-center gap-2 rounded-xl border border-background-200 bg-background-50/95 px-4 py-2.5 backdrop-blur sm:flex">
            <i className="ri-radar-line text-lg text-primary-500" aria-hidden="true"></i>
            <span className="text-xs text-foreground-700">实时测速中</span>
          </div>
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
        <div className="grid grid-cols-2 gap-3 rounded-2xl border border-background-200 bg-background-100 p-4 md:grid-cols-4 md:gap-4 md:p-6">
          {heroStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl text-primary-600 md:text-4xl">
                {stat.value}
                <span className="ml-0.5 text-base text-foreground-600">{stat.unit}</span>
              </p>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}